import { RegisterImplementationProps } from 'constants/types';
import SignInBase from '../SignInBase';
import MainContainer from '../SignInMainContainer';
import LoaderButton from 'components/Button/LoaderButton';
import Input from 'components/Input/Input';
import { getProviderFormLabel } from '../utils';

const SignInAppliedBusinessSolutionsApi = ({
  isLoading,
  onSubmit,
  provider,
}: RegisterImplementationProps) => {
  const instructions: JSX.Element = (
    <>
      <p>
        Enter your 6 digit <strong>Applied Business Solutions</strong> client
        ID.
      </p>
      <p>
        Your account&apos;s connection will not be complete until{' '}
        <strong>Applied Business Solutions</strong> completes its setup. Please
        allow 7 business days for this.
      </p>
    </>
  );

  return (
    <SignInBase
      formLabel={getProviderFormLabel(provider)}
      instructions={instructions}
      divider
      onSubmit={onSubmit}
      fieldNames={['companyId']}
      render={({ companyId }) => {
        return (
          <>
            <MainContainer useNewDesign>
              <Input
                id="companyId"
                label="Client ID"
                characterLimit={6}
                invalid={companyId.invalid}
                value={companyId.value}
                onChange={(event) => companyId.onChange(event.target.value)}
              />
            </MainContainer>
            <LoaderButton
              isLoading={isLoading}
              disabled={isLoading || !companyId.value}
              type="submit"
              text="Connect"
            />
          </>
        );
      }}
    />
  );
};

export default SignInAppliedBusinessSolutionsApi;
